module.exports = __webpack_public_path__ + "img/2483795.jpg";